import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { useCompanies, useStore } from 'zens-store'
import { useRouter } from 'zens-router'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
})

const HomeRedirect = () => {
  const router = useRouter()
  const { message } = useStore()
  const { t } = useTranslation()

  const companies = useCompanies()

  useEffect(() => {
    if (!companies.isFetched) return

    if (companies.data?.length === 1) {
      console.debug(`COMPANY: Redirecting to company ${companies.data?.[0]?.id}`)
      router.replace(`/companies/${companies.data?.[0]?.id}`)
    } else {
      console.debug(`COMPANY: Redirecting to all companies`)
      router.replace(`/companies`)
    }
    if (companies.isError) {
      const { message: errorMessage } = companies.error
      console.debug(`COMPANY: Companies load failed: ${errorMessage}`)
      message.add({
        message: `${t('Companies data could not be loaded')}. ${errorMessage}`,
        status: 'error',
      })
    }
  }, [companies.isFetched])

  return <View style={styles.container} />
}

export default HomeRedirect
